export const figure18h = {
  chart: {
      type: 'line',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
        height: 230,
      plotBackgroundColor: null,
      plotBorderWidth: null,
    },
    credits: {
      enabled: false
  },
    title: {
      text: 'République-Unie de Tanzanie'
    },
    subtitle: {
      text: null
  },
    xAxis: {
      categories: ['2009','2011','2013', '2015']
    },
    labels: {
      	
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    yAxis: {
      min: 0,
      max: 1600,
      tickInterval: 400,
      title: {
          text: null,
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: false
        },
        enableMouseTracking: true
      }
    },
    legend: {
      enabled: false,
  },
    colors: ['#5b9bd5', '#ed7d32','#cbcccb', '#ffc100'],
    series: [{
      name: 'Petites exploitations',
      data: [347, 373, 494, 504,]
    }, {
      name: 'Autres exploitations',
      data: [1342, 1019, 1306, 1375,]
    },{
      name: 'Petites exploitations dirigées par une femme',
      data: [282, 282, 424, 428,]
    },{
      name: 'Petites exploitations dirigées par un homme',
      data: [374, 412, 524, 540,]
    }]
  }

  